Filters on hirer names containing the provided case-insensitive substring.

This is intended to support ad-hoc searches for hirers by name.
